/**
 * Format FastAPI/Pydantic validation `detail` arrays into readable messages.
 * @param {unknown} detail
 * @returns {string | null}
 */
export function formatApiValidationDetail(detail) {
  if (!detail) return null;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (typeof item === 'string') return item;
        const loc = Array.isArray(item?.loc)
          ? item.loc.filter((part) => part !== 'body').join('.')
          : '';
        const message = item?.msg || item?.message || 'Validation error';
        return loc ? `${loc}: ${message}` : message;
      })
      .join('; ');
  }
  if (typeof detail === 'object') {
    try {
      return JSON.stringify(detail);
    } catch {
      return String(detail);
    }
  }
  return String(detail);
}
